import { assert_string_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { EUserSupportMessageTopic } from './EUserSupportMessageTopic';

export class DTOUserSupportMessage extends DTO__database_entity {
  static _class_name_static: string = ENUM__dto_class_name.USER_SUPPORT_MESSAGE;

  /*
   * FIELDS
   */
  workspace_id!: string;

  language_from_browser!: string;
  email_from_form!: string;
  message!: string;
  topic!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_not_empty(this.workspace_id);

    assert_type_enum(this.language_from_browser, ENUM__language_type);
    assert_string_not_empty(this.email_from_form);
    assert_string_not_empty(this.message);
    assert_type_enum(this.topic, EUserSupportMessageTopic);
  }
}
